module.exports = __webpack_public_path__ + "media/images/favicon_logo_white-717eb5e702b5837d474710a5b5d337b9.svg";